import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import packageService from '../../services/api/packageService';

export const fetchPackages = createAsyncThunk(
  'packages/fetchPackages',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await packageService.getAllPackages(filters);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPackageById = createAsyncThunk(
  'packages/fetchPackageById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await packageService.getPackageById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  packages: [],
  currentPackage: null,
  loading: false,
  error: null,
};

const packageSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    clearCurrentPackage: (state) => {
      state.currentPackage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.packages = action.payload;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPackageById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPackageById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPackage = action.payload;
      })
      .addCase(fetchPackageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCurrentPackage } = packageSlice.actions;
export default packageSlice.reducer;

